
import { Form, Field, FormActions, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import { computed, onActivated, ref, watch } from "vue";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import { RequestedAction } from "@moderrotech/servers-communication-library/src/types";
import _ from "lodash";

export default {
  components: {
    Form,
    Field
    // ErrorMessage
  },
  setup() {
    const store = useStore();
    const isSubmitting = ref(false);

    const inputRef = ref();

    const handleSubmit = (
      values: { [k: string]: string },
      actions: FormActions<any>
    ) => {
      isSubmitting.value = true;
      store.dispatch("session/sendTextHint", {
        data: {
          text: values.message
        },
        callback: () => {
          isSubmitting.value = false;
          showToastSuccess(i18n.global.t("call.success.textMessage"));
          actions.resetForm();
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.showTextMessageForm
          );
        },
        errorCallback: () => {
          isSubmitting.value = false;
          showToastError(i18n.global.t("call.error.textMessage"));
        }
      });
    };

    onActivated(() => {
      store.commit(
        "session/UNSET_REQUESTED_ACTION",
        RequestedAction.hideTextMessageForm
      );
      inputRef.value.focus();
    });

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.hideTextMessageForm
        ),
      v => {
        if (v) {
          _.forEach(
            [
              RequestedAction.hideTextMessageForm,
              RequestedAction.showTextMessageForm
            ],
            a => store.commit("session/UNSET_REQUESTED_ACTION", a)
          );
        }
      }
    );

    return {
      isSubmitting,
      handleSubmit,
      inputRef
    };
  }
};
